import { Component, OnInit, inject } from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl,
} from '@angular/platform-browser';
import {
  DxButtonComponent,
  DxFileUploaderComponent,
  DxLoadPanelComponent,
} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { ParametriStampa } from 'src/app/models/parametri-stampa';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriStampaService } from 'src/app/shared/services/parametri-stampa.service';

@Component({
  selector: 'app-parametri-grafici',
  templateUrl: './parametri-grafici.component.html',
  styleUrls: ['./parametri-grafici.component.scss'],
  imports: [
    DxButtonComponent,
    DxFileUploaderComponent,
    DxLoadPanelComponent
  ],
  standalone: true,
})
export class ParametriGraficiComponent implements OnInit {
  private paramateriStampaS = inject(ParametriStampaService);
  private nS = inject(NavigatorService);
  private sanitizer = inject(DomSanitizer);

  parametriStampa: ParametriStampa;
  files: any;
  strLogoBase64: string;
  currentLogo: SafeResourceUrl;
  visibleLoadPanel = false;

  ngOnInit() {
    this.getParametri();
  }

  getParametri() {
    //this.parametriStampa = new ParametriStampa();
    this.visibleLoadPanel = true;
    this.paramateriStampaS.get('DPI').subscribe({
      next: (dati) => {
        this.visibleLoadPanel = false;
        if (dati != null) {
          this.parametriStampa = dati;
          this.currentLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image;base64,' + this.parametriStampa.logoBase64,
          );

          this.parametriStampa.oggetto = null;
          this.parametriStampa.luogo = null;
          this.parametriStampa.paragrafo1 = null;
          this.parametriStampa.paragrafo2 = null;
          this.parametriStampa.paragrafo3 = null;
          this.parametriStampa.paragrafo4 = null;
          this.parametriStampa.paragrafo5 = null;
          this.parametriStampa.footer1 = null;
          this.parametriStampa.footer2 = null;
          this.parametriStampa.footer3 = null;

          this.parametriStampa.logoFileName = null;
          this.parametriStampa.headerFileName = null;
          this.parametriStampa.firmaTimbroFileName = null;

          this.parametriStampa.logoBase64 = null;
          this.parametriStampa.headerBase64 = null;
          this.parametriStampa.firmaTimbroBase64 = null;
        }
      },
      error: (error) => {
            this.visibleLoadPanel = false;
            notify('Errore salvataggio dati', 'error', 2000);
          },
    });
  }

  //Button "Salva"
  SalvaParametri(e) {
    const result = e.validationGroup.validate();
    if (result.isValid) {
      this.visibleLoadPanel = true;
      this.paramateriStampaS
        .insert(this.parametriStampa, 'DPI')
        .subscribe({
          next: (res) => {
            this.visibleLoadPanel = false;
            //if (dati.id> 0){
            notify({
              message: 'Parametri grafici salvati correttamente',
              width: 300,
              shading: true,
              type: 'success',
            });
          },
          error: (error) => {
            this.visibleLoadPanel = false;
            notify('Errore salvataggio dati', 'error', 2000);
          },
        });
    } else {
      notify('Compilare i campi obbligatori', 'warning', 2000);
    }
  }

  getLogo(event) {
    this.files = event.target.files;
    const reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(this.files[0]);
    this.parametriStampa.logoFileName = this.files[0].name;
  }

  _handleReaderLoaded(readerEvt) {
    const dataUrl = readerEvt.target.result as string;
    const base64 = dataUrl.split(',')[1];
    console.log("Conversione logo base 64");
    this.strLogoBase64 = base64; // Converting binary string data.
    this.parametriStampa.logoBase64 = this.strLogoBase64;

    this.currentLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
      'data:image;base64,' + this.parametriStampa.logoBase64,
    );
  }
}

